import React, { Component } from 'react'
import { observer } from 'mobx-react'
import contactImg from '../../assets/contact.svg'
import { billingStore, channelStore } from '../../app/stores'
import { BlankSlate, Button } from '../../lib'
import moment from 'moment'

class Contact extends Component {
  render(){
    return (
    <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #E6EBEA" }}>
      <div style={{textAlign: "left"}}>
        <h4 style={{marginBottom: 0}}>{this.props.data.name}</h4>
         <p style={{marginTop: 5, fontSize: 12, opacity: .7}}>
          {this.props.data.email || this.props.data.contact}
        </p>
        <p style={{marginTop: 5, fontSize: 12, opacity: .7}}>
          {moment(this.props.data.dateCreated).fromNow()}
        </p>
      </div>
      <p>{this.props.data.email}</p>
    </div>
    )
  }
}

class Contacts extends Component {
  componentDidMount() {
    channelStore.loadContacts(channelStore.channelId);
  }
  exportCsv(){
    var csv = "Email Address,  Name" + "\r\n"
    Object.values(channelStore.contacts).sort((a,b) => b.dateCreated - a.dateCreated).forEach(x => csv += ((x.email || x.contact) ? (x.email || x.contact).replace(/,/g , ".") : "") + ", " + (x.name ? x.name.replace(/,/g , ".") : "unknown") + "\r\n")
    var mimeType = 'text/csv;charset=utf-8;'
    var fileName = "Smallchat Contacts.csv"

    //sorry robert
    var a = document.createElement('a');
    if (navigator.msSaveBlob) { // IE10
      return navigator.msSaveBlob(new Blob([csv], { type: mimeType }), fileName);
    } else if ('download' in a) { //html5 A[download]
      a.href = 'data:' + mimeType + ',' + encodeURIComponent(csv);
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      return true;
    }
  }
  render(){
    if (!billingStore.hasContactsAccess) {
      return (
        <BlankSlate
          img={contactImg}
          title='Contacts'>
          <p>
            To access your contact list you'll need to&nbsp;
            <Button styleType='text' to='/account/billing'>
              upgrade your plan
            </Button>.
          </p>
      </BlankSlate>
      )
    } else if (channelStore.contacts) {
      return (
        <div style={{ textAlign: 'right' }}>
          <Button onClick={this.exportCsv}>Download Contacts as CSV</Button>
          <div style={{marginTop: 15}}>
          {Object.values(channelStore.contacts).sort((a,b) => b.dateCreated - a.dateCreated).map((contact,i) =>
            <Contact key={i} data={contact} />
          )}
          </div>
        </div>
      )
    } else {
      return (
        <p>When visitors leave their name and email, their contact will appear here.</p>
      )
    }

  }
}

Contacts.displayName = 'Contacts'

export default observer(Contacts)



// WEBPACK FOOTER //
// ./src/channel/contacts/Contacts.js